import React, { Component } from 'react';
import Table from '../../../../components/Table';
import CertificateFormModal from './components/CertificateFormModal'
import CertificateDetailModal from './components/CertificateDetailModal'
import DeleteCertificateModal from './components/DeleteCertificateModal'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CertificatesListSGroups } from '../../utils/CertificatesListSGroups';
import _ from 'lodash'

class Certificates extends Component {
    static contextTypes = { api: PropTypes.object };
    constructor(props) {
        super(props);
        this.state = {

        };
        this.loadData = _.debounce(this.loadData, 450);

    }

    loadData = (tableState) => {
        this.tableState = tableState;
        if (tableState.filters.congress) tableState.filters['congress.name'] = tableState.filters.congress;
        const filters = {
            'order[id]': 'DESC',
            sGroups: CertificatesListSGroups,
            ...tableState.filters
        };
        this.context.api.certificates.get(tableState.page, tableState.pageSize, '@Class.Certificates.diplomas.get', filters)
    };


    openAddCertificate = () => this.setState({ addingCertificate: true });

    closeAddCertificate = () => this.setState({ addingCertificate: false });

    onDetailCertificate = (diploma) => this.setState({ detailingCertificate: diploma });

    closeDetailCertificate = () => this.setState({ detailingCertificate: false });

    onEditCertificate = (e) => {
        e.stopPropagation();
        this.setState({ editingCertificate: e.currentTarget.dataset.index })
    };

    closeEditCertificate = () => this.setState({ editingCertificate: false });

    onDeleteCertificate = (e) => {
        e.stopPropagation();
        this.setState({ deletingCertificate: e.currentTarget.dataset.index })
    };

    deleteCertificate = (certificate) => {
        this.context.api.certificates.delete(certificate.id);
        this.closeDeleteCertificate();
    };

    closeDeleteCertificate = () => this.setState({ deletingCertificate: false });

    tableDefinition =
        [
            {
                name: 'Acciones',
                accessor: (data, index) =>
                    <span>
                        <button className='btn btn-xs btn-primary' data-index={index} onClick={this.onEditCertificate}><i className='ti-pencil' /></button>&nbsp;
                        <button className='btn btn-xs btn-danger' data-index={index} onClick={this.onDeleteCertificate}><i className='ti-trash' /></button>
                    </span>
            }, {
                name: 'Nombre',
                id: 'name',
                filterable: true,
                accessor: 'name',
            }, {
                name: 'Congreso',
                id: 'congress.name',
                filterable: true,
                accessor: (certificate) => certificate.congress ? certificate.congress.name : 'N/A'
            }, {
                name: 'Evento',
                id: 'event.name',
                filterable: true,
                accessor: (certificate) => certificate.event ? certificate.event.name : 'N/A'
            }
        ];

    render() {
        return (
            <div className="container-fluid Directory">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Listado de constancias</h4>
                            </div>
                            <div className="card-content">
                                <div className='buttonContainer'>
                                </div>
                                <div className='buttonContainer'>
                                    <button className='btn btn-success btn-fill btn-magnify pull-right' onClick={this.openAddCertificate}>
                                        <span className='btn-label'><i className='ti-plus' /></span>
                                    </button>
                                    <a href={this.context.api.certificates.exportUrl(this.tableState ? { ...this.tableState.filters } : null, 'xlsx')}>
                                        <button className='btn btn-info btn-fill btn-magnify pull-right download-report'>
                                            <span className='btn-label'>Descargar excel</span>
                                        </button>
                                    </a>
                                    <a href={this.context.api.certificates.exportUrl(this.tableState ? { ...this.tableState.filters } : null, 'pdf')}>
                                        <button className='btn btn-info btn-fill btn-magnify pull-right download-report'>
                                            <span className='btn-label'>Descargar PDF</span>
                                        </button>
                                    </a>
                                    <div className='clearfix' />
                                </div><br />
                                <Table
                                    paginated
                                    defaultPageSize={50}
                                    rowIdAccessor={'id'}
                                    totalItems={this.props.certificatesMeta.totalItems}
                                    loadData={this.loadData}
                                    columns={this.tableDefinition}
                                    data={this.props.certificates}
                                    trProps={(constancia) => ({ onClick: () => this.onDetailCertificate(constancia) })}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/*New diploma Modal */}
                {this.state.addingCertificate ?
                    <CertificateFormModal
                        onHide={this.closeAddCertificate}
                    /> : null}
                {/*  Edit diploma Modal */}
                {this.state.editingCertificate ?
                    <CertificateFormModal
                        onHide={this.closeEditCertificate}
                        editing={this.props.certificates[this.state.editingCertificate]}
                    /> : null}
                {/* Delete diploma Modal*/}
                {this.state.deletingCertificate ?
                    <DeleteCertificateModal
                        certificate={this.props.certificates[this.state.deletingCertificate]}
                        onHide={this.closeDeleteCertificate}
                        onConfirm={this.deleteCertificate}
                    /> : null}
                {/* Show diploma detail Modal*/}
                {this.state.detailingCertificate ?
                    <CertificateDetailModal
                        certificate={this.state.detailingCertificate}
                        onHide={this.closeDetailCertificate}
                    />
                    : null}
            </div>
        );
    }
}

const mapStateToProps = ({ api: { certificates = [], certificatesMeta = {} } }) => {
    return { certificates, certificatesMeta }
};

export default connect(mapStateToProps)(Certificates);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/Certificates/index.jsx